var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',_vm._g({},_vm.$listeners),[(_vm.requiredFields)?_c('p',[_vm._v("Bitte füllen Sie alle mit * gekennzeichneten Felder aus.")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }